import React from 'react';
import {Outlet} from 'react-router-dom';
import styled from 'styled-components';
import {Container, Row, Col} from 'react-grid-system';
import {NavLink} from 'react-router-dom';
import Brand from '../../components/brand';
import Flex from '../../components/flex';
import Language from '../../components/lang';
import {useTranslation} from 'react-i18next';
import Box from '../../components/box';

const Styled = styled.div`
  padding: 20px 25px;
  border-bottom: 1px solid #a8a8a8;

  .nav-link {
    font-size: 16px;
    display: inline-block;
    padding: 10px 30px;
    color: #000;
    margin-left: 30px;
    border-radius: 5px;

    &:hover {
      background-color: #1d283a;
      color: #fff;
    }
  }

  .box {
    margin-top: 15vh;
  }
`;

const PasswordChangeLayout = ({...rest}) => {
    const {t} = useTranslation();
    return (
        <Styled {...rest}>
            <Container fluid>
                <Row align={'center'}>
                    <Col xs={6}>
                        <Brand/>
                    </Col>
                    <Col className={'text-right'} xs={6}>
                        <Flex justify={'flex-end'}>
                            <Language/>
                            <NavLink className={'nav-link'} to={'/auth/logout'}>
                                {t('Выйти')}
                            </NavLink>
                        </Flex>
                    </Col>
                </Row>
            </Container>
            <div className="box">
                <Container>
                    <Row justify={'center'}>
                        <Col xs={4}>
                            <Box>
                                <Outlet/>
                            </Box>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Styled>
    );
};

export default PasswordChangeLayout;
